import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-primary-500 text-background-50">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <h3 className="text-2xl font-bold font-heading mb-4">51app</h3>
            <p className="text-sm leading-relaxed text-background-100 max-w-xs">
              全网最热门的吃瓜爆料平台，第一时间掌握网红八卦、明星绯闻、聊天记录曝光、视频爆料等劲爆内容。免费下载，实时更新。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <span className="w-9 h-9 flex items-center justify-center rounded-full border border-background-200/40 hover:border-accent-500 hover:text-accent-500 transition-colors cursor-pointer">
                <i className="ri-wechat-fill text-lg w-5 h-5 flex items-center justify-center" />
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full border border-background-200/40 hover:border-accent-500 hover:text-accent-500 transition-colors cursor-pointer">
                <i className="ri-chat-1-fill text-lg w-5 h-5 flex items-center justify-center" />
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full border border-background-200/40 hover:border-accent-500 hover:text-accent-500 transition-colors cursor-pointer">
                <i className="ri-qq-fill text-lg w-5 h-5 flex items-center justify-center" />
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full border border-background-200/40 hover:border-accent-500 hover:text-accent-500 transition-colors cursor-pointer">
                <i className="ri-rss-fill text-lg w-5 h-5 flex items-center justify-center" />
              </span>
            </div>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-xs uppercase tracking-wider font-medium text-background-200 mb-4">
              热门分类
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-100 hover:text-accent-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs uppercase tracking-wider font-medium text-background-200 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/"
                  className="text-sm text-background-100 hover:text-accent-400 transition-colors"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-100 hover:text-accent-400 transition-colors"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <a
                  href="#download"
                  className="text-sm text-background-100 hover:text-accent-400 transition-colors"
                >
                  下载APP
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-background-100 hover:text-accent-400 transition-colors"
                >
                  用户协议
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-background-100 hover:text-accent-400 transition-colors"
                >
                  隐私政策
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs uppercase tracking-wider font-medium text-background-200 mb-4">
              联系我们
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2.5">
                <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5 text-accent-400">
                  <i className="ri-mail-line" />
                </span>
                <span className="text-sm text-background-100">
                  hello@lalaccu.cn
                </span>
              </li>
              <li className="flex items-start gap-2.5">
                <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5 text-accent-400">
                  <i className="ri-phone-line" />
                </span>
                <span className="text-sm text-background-100">
                  400-888-5151
                </span>
              </li>
              <li className="flex items-start gap-2.5">
                <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5 text-accent-400">
                  <i className="ri-map-pin-line" />
                </span>
                <span className="text-sm text-background-100">
                  杭州市滨江区互联网小镇A座
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-10 md:mt-14 pt-6 border-t border-background-400/30">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-200">
              © 2026 51app. All rights reserved. 本站内容来源于网络，如有侵权请联系我们删除。
            </p>
            <div className="flex items-center gap-4">
              <Link
                to="/about"
                className="text-xs text-background-200 hover:text-background-50 transition-colors"
              >
                关于我们
              </Link>
              <Link
                to="/"
                className="text-xs text-background-200 hover:text-background-50 transition-colors"
              >
                首页
              </Link>
              <a
                href="#"
                className="text-xs text-background-200 hover:text-background-50 transition-colors"
              >
                免责声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
